import { PlanFieldState } from '@/modules/plan/plan.types';
import { baseStoreCreator } from '@/utils/store';

export interface AccountFundingParamsFieldsStatePayload {
  isReplenished: PlanFieldState;
  planLevelFunding: PlanFieldState;
  omnibus: PlanFieldState;
  accountCreation: PlanFieldState;
  isForfeitAllowed: PlanFieldState;
  forfeitureDays: PlanFieldState;
  isPreFundCalculated: PlanFieldState;
  replenishmentCreepMin: PlanFieldState;
  replenishmentCreepPercent: PlanFieldState;
  replenishmentMinValue: PlanFieldState;
  replenishmentPercent: PlanFieldState;
  isParticipantPaidMaintenanceFee: PlanFieldState;
  maintenanceFee: PlanFieldState;
  applyFeeTo: PlanFieldState;
  cashBalanceThreshold: PlanFieldState;
  fundingMethod: PlanFieldState;
  eoyPlanReconciliation: PlanFieldState;
  eoyPlanReconciliationDelayDays: PlanFieldState;
  billingMethodTypeId: PlanFieldState;
  externalBankAccount: PlanFieldState;
  externalPushReturnAccount: PlanFieldState;
  contributionHoldPeriod: PlanFieldState;
  contributionPushGiveUpDays: PlanFieldState;
}

export const DEFAULT_VALUES: AccountFundingParamsFieldsStatePayload = {
  planLevelFunding: PlanFieldState.Modifiable,
  omnibus: PlanFieldState.Modifiable,
  accountCreation: PlanFieldState.Modifiable,
  isForfeitAllowed: PlanFieldState.Modifiable,
  forfeitureDays: PlanFieldState.Modifiable,
  isPreFundCalculated: PlanFieldState.Modifiable,
  replenishmentCreepMin: PlanFieldState.Modifiable,
  replenishmentCreepPercent: PlanFieldState.Modifiable,
  replenishmentMinValue: PlanFieldState.Modifiable,
  replenishmentPercent: PlanFieldState.Modifiable,
  isParticipantPaidMaintenanceFee: PlanFieldState.Modifiable,
  maintenanceFee: PlanFieldState.Modifiable,
  applyFeeTo: PlanFieldState.Modifiable,
  cashBalanceThreshold: PlanFieldState.Modifiable,
  fundingMethod: PlanFieldState.Modifiable,
  eoyPlanReconciliation: PlanFieldState.Modifiable,
  eoyPlanReconciliationDelayDays: PlanFieldState.Modifiable,
  billingMethodTypeId: PlanFieldState.Modifiable,
  externalBankAccount: PlanFieldState.Modifiable,
  externalPushReturnAccount: PlanFieldState.Modifiable,
  contributionHoldPeriod: PlanFieldState.Modifiable,
  contributionPushGiveUpDays: PlanFieldState.Modifiable,

  //TODO: need to remove after new funding fields implementation (after remove FF from UI)
  isReplenished: PlanFieldState.Modifiable,
};

export const useStore = baseStoreCreator<AccountFundingParamsFieldsStatePayload>(DEFAULT_VALUES);

export default useStore;
